import DOMPurify from "dompurify";

export default function DescricaoHu({ html, text }) {
  if (typeof html === "string" && html.length > 0) {
    const sanitizedHtml = DOMPurify.sanitize(html, {
      USE_PROFILES: { html: true },
    });

    return (
      <div
        className="hu-description-html"
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
    );
  }

  return <div className="hu-description-text">{text || "Sem descrição"}</div>;
}
